/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { PurchasePriceHead } from "../../../../../config/constant";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { PurchaseTopBar, PurchaseCustomTable, PurchaseCustomForm } from "./Purchase";
import { checkViewPermission } from '../../../../../helpers/utilities';
import moment from 'moment';
import productActions from "../../../../Product/Product/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import actions from "../../redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";


const PurchasePrice = React.forwardRef((props, ref) => {
    const { createDetails, createError, editDetails, editError, createData } = useSelector(state => state.crudReducer);
    const { purchasePriceDetails, purchasePriceLoader } = useSelector(state => state.productSetupReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { productPrices } = useSelector(state => state.productProductReducer);
    const [loadMore, setLoadMore] = useState(false);
    const { title, supplierId, groupId, roleManagement, history, topBarView } = props;
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [form, setForm] = useState({ 'isActive': true });
    const [error, setError] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const dispatch = useDispatch();
    const [view, setView] = useState(false);
    const [priceId, setPriceId] = useState('');
    const [visible, setVisible] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [dateValue, setDateValue] = useState([null, null]);
    const [productChange, setProductChange] = useState(false);
    const [topBar, setTopBar] = useState({
        'status': "active",
        'customSupplierId': supplierId,
        'customGroupId': groupId
    });

    const handleKeyDown = (e) => {
        if (topBarView && e.altKey && e.keyCode === 78) {
            e.preventDefault();
            handleEmpty(true);
        } else if (topBarView && e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (visible) {
                handleSubmit(e);
            }
        } else if (topBarView && e.altKey && e.keyCode === 69) {
            e.preventDefault();
            if (visible && view) {
                onEdit(form);
            }
        }
    }
    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Supplier Purchase Price', history, 'Purchase')) {
                dispatch({
                    type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                        order: 'id desc'
                    }
                });
                productApi();
            }
        }
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
        };
    }, [roleManagement]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Supplier Purchase Price', history, 'Purchase')) {
                dispatchFilter(dateValue, sortBy, sortOrder);
            }
        }
    }, [topBar, roleManagement]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(dateValue, sortBy, sortOrder);
    }

    const dispatchFilter = (dateValue, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { "and": [] };
        let or = { "or": [] }


        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ fromDate: { gte: moment(dateValue[0]).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(dateValue[1]).format('YYYY-MM-DD') } });
        }

        if (topBar?.status) {
            filter['and'].push({ isActive: topBar?.status === 'active' ? true : false });
        }

        if (topBar?.supplierId !== '' || topBar?.customSupplierId) {
            //let cusOr = { "or": [] }
            if (topBar?.customSupplierId) {
                if (topBar?.customGroupId) {
                    or['or'].push({ customerGroupId: topBar?.customGroupId });
                }
                or['or'].push({ supplierId: topBar?.customSupplierId });
            } else {
                filter['and'].push({ supplierId: topBar?.supplierId });
            }
        }

        // if (topBar?.supplierId) {
        //     filter['and'].push({ supplierId: topBar?.supplierId });
        // }


        if (topBar?.productId) {
            filter['and'].push({ productId: topBar?.productId });
        }

        if (topBar?.search && topBar?.search !== '') {
            or['or'].push({ purchasePriceId: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ price: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ maxRetailPrice: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ cost: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ lastPurchasePrice: { like: '%' + topBar?.search.trim() + '%' } });
        }

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'purchase-prices',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const handleProductChange = (data) => {
        setForm({
            ...form,
            'productId': data?.id,
            'unitId': data?.salesUnitId || '',
            'maxRetailPrice': data?.mrp ? parseInt(data?.mrp) : '',
            'cost': data?.costPrice || '',
            'useMrp': data?.useMrp ? true : false,
        });
        setError({});
        setProductChange(true);
        dispatch({
            type: productActions.PRODUCT_PRICE_START,
            url: `/purchasedprice/${data?.id || 0}`
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'PURCHASE' } }] }] };
        let or = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }



    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (createData?.error?.message) {
                setCommonError(createData?.error?.message);
            } else {
                toast.dismiss();
                toast(createDetails);
                handleEmpty(false); dispatchFilter(dateValue, sortBy, sortOrder);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            setCommonError(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        handleSetProductPrice(form?.unitId, productChange);
    }, [productPrices]);

    const handleSetProductPrice = (unitId, productChange) => {
        if (productPrices && productPrices !== '' && productChange) {
            if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                productPrices?.lastprice[customObject(unitMesurementdetails, unitId)?.name]) {
                let result = productPrices?.lastprice[customObject(unitMesurementdetails, unitId)?.name];
                setForm({
                    ...form,
                    'lastPurchasePrice': result?.price,
                    'maxRetailPrice': result?.mrp
                });
            }
            setProductChange(false);
        }
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(dateValue, sortBy, sortOrder, s);
    }

    const onDelete = (data) => {
        setPriceId(data?.id);
        setForm({ ...data });
        setDeleteModal(true);
    }

    useEffect(() => {
        if (!supplierId && prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            handleEmpty(false); dispatchFilter(dateValue, sortBy, sortOrder);
        } else if (!supplierId && prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);

    const onEdit = (data) => {
        setView(false);
        setPriceId(data?.id);
        setForm({ ...data });
        productApi('', data.productId);
        setVisible(true);
        dispatch({
            type: productActions.PRODUCT_PRICE_START,
            url: `/purchasedprice/${data.productId}`
        });
    }

    const onView = (data) => {
        setView(true);
        setPriceId(data?.id);
        productApi('', data.productId);
        setForm({ ...data });
        setVisible(true);
    }

    const handleCopy = (data) => {
        setView(false);
        setPriceId('');
        setForm({ ...data });
        setVisible(true);
    }

    const handleDates = (value) => {
        setDateValue(value);
        dispatchFilter(value, sortBy, sortOrder);
    }

    const handleDeactive = (data) => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "purchase-prices",
            title: "Purchase Price",
            id: data?.id,
            details: {
                'isActive': !data?.isActive
            }
        })
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'useMrp') {
                setForm({
                    ...form,
                    [name]: !form?.useMrp,
                });
            } else if (name === 'unitId') {
                let productData = customObject(myProductdetails, form?.productId);
                let data = {};
                if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                    productPrices?.lastprice[customObject(unitMesurementdetails, e)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, e)?.name];
                    data = {
                        'lastPurchasePrice': result?.price,
                        'maxRetailPrice': result?.mrp
                    };
                }
                setForm({
                    ...form, ...data,
                    [name]: e,
                    useMrp: productData?.salesUnitId !== e ? false : productData?.useMrp
                });
            } else if (name === 'specialExcisesDutyPercentage') {
                let mrpPercentage = (parseFloat(form?.maxRetailPrice || 0) * parseFloat(e)) / 100;
                setForm({
                    ...form,
                    [name]: e,
                    'specialExcisesDuty': parseFloat(mrpPercentage)
                });
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyProductId = emptyValidation('Product', form?.productId, 'dropDown');
        let emptyUnitId = emptyValidation('Unit', form?.unitId, 'dropDown');
        let emptyPrice = emptyValidation('Price', form?.price);
        let emptySupplier = emptyValidation('Supplier', form?.supplierId, 'dropDown');
        let checkPrice = { isValid: true, errors: '' };

        if (form?.useMRP && form?.maxRetailPrice !== '' && form?.maxRetailPrice !== null && form?.price > form?.maxRetailPrice) {
            checkPrice = { isvalid: false, errors: 'Sales price is greated than MRP Price' };;
        }
        let date = true;
        let fromDate = moment(form?.fromDate).format("YYYY-MM-DD");
        let toDate = moment(form?.toDate).format("YYYY-MM-DD");
        if (form?.fromDate && form?.toDate) {
            if (moment(toDate).diff(moment(fromDate), 'days') < 0) {
                date = false;
            }
        }
        setError({});
        if (emptyProductId.isValid &&
            emptyUnitId.isValid &&
            emptyPrice.isValid && date && checkPrice.isValid && emptySupplier.isValid
        ) {
            delete form.id; delete form.createTs; delete form.product;
            delete form.supplier; delete form.business; delete form.unit;

            if (form?.maxRetailPrice) {
                form.maxRetailPrice = parseFloat(form?.maxRetailPrice);
            }

            if (form?.price) {
                form.price = parseFloat(form?.price);
            }

            if (form?.cost) {
                form.cost = parseFloat(form?.cost);
            }

            if (form?.lastPurchasePrice) {
                form.lastPurchasePrice = parseFloat(form?.lastPurchasePrice);
            }

            if (form?.fromDate) {
                form.fromDate = moment(form?.fromDate).format("YYYY-MM-DD")
            }

            if (form?.toDate) {
                form.toDate = moment(form?.toDate).format("YYYY-MM-DD")
            }

            if (form?.specialExcisesDutyPercentage) {
                form.specialExcisesDutyPercentage = parseFloat(form?.specialExcisesDutyPercentage);
            }

            if (form?.specialExcisesDuty) {
                form.specialExcisesDuty = parseFloat(form?.specialExcisesDuty);
            }

            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));

            dispatch({
                type: priceId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "purchase-prices",
                title: "Purchase Price",
                method: "put",
                id: priceId,
                details: data
            })
        } else {
            setError({
                'productId': emptyProductId.errors,
                'unitId': emptyUnitId.errors,
                'price': emptyPrice.errors || checkPrice.errors,
                'supplierId': emptySupplier.errors,
                'toDate': date ? '' : 'To date is not lesser than from date'
            })
        }
    }

    const handleEmpty = (d) => {
        setVisible(d);
        setError({});
        setView(false);
        setForm({ 'isActive': true });
        setCommonError(false);
        setPriceId('');
        productApi();
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx', exportType = 'export') => {
        let filter = { "and": [] };

        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ fromDate: { gte: moment(dateValue[0]).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(dateValue[1]).format('YYYY-MM-DD') } });
        }

        if (topBar?.status) {
            filter['and'].push({ isActive: topBar?.status === 'active' ? true : false });
        }

        if (topBar?.supplierId) {
            filter['and'].push({ supplierId: topBar?.supplierId });
        }

        if (topBar?.productId) {
            filter['and'].push({ productId: topBar?.productId });
        }

        dispatch({
            type: actions.PURCHASE_PRICE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            exportType: exportType,
            url: 'purchase-prices',
            filter: {
                // eslint-disable-next-line no-useless-computed-key
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }
    const handleMobileFilter = (data) => {
        if (data?.startDate && data?.endDate) {
            setDateValue([data?.startDate, data?.endDate]);
        } else {
            setDateValue([null, null]);
        }
        setTopBar(data);
    }

    return (
        <React.Fragment>
            <PurchaseTopBar
                topBarView={topBarView}
                onImportVisible={(v) => setImportVisible(v)}
                title={title}
                topBar={topBar}
                loadImportExportData={(name) => loadImportExportData(name)}
                handleDatesParent={(value) => handleDates(value)}
                handleSupplier={(supplierId) => setTopBar({
                    ...topBar,
                    'supplierId': supplierId
                })}
                handleProduct={(productId) => setTopBar({
                    ...topBar,
                    'productId': productId
                })}
                handleStatus={(value) => setTopBar({
                    ...topBar,
                    'status': value
                })}
                handleSearch={(value) => setTopBar({
                    ...topBar,
                    'search': value
                })}
                handleCreate={() => handleEmpty(true)}
                productApi={(s = '', id = '') => productApi(s, id)}
                handleMobileFilter={(data) => handleMobileFilter(data)}
                roleManagement={roleManagement}
                dateValue={dateValue}

            />
            <PurchaseCustomTable
                supplierId={supplierId}
                topBar={topBar}
                dateValue={dateValue}
                heads={PurchasePriceHead}
                roleManagement={roleManagement}
                loadMoreContent={loadMoreContent}
                handleDeactive={(data) => { handleDeactive(data) }}
                sortOrder={sortOrder}
                loadMore={loadMore}
                loadMoreTask={() => loadMoreTask()}
                details={getList}
                sortBy={sortBy}
                {...props}
                onEdit={(data) => onEdit(data)}
                onView={(data) => onView(data)}
                onDelete={(data) => onDelete(data)}
                handleCopy={(data) => handleCopy(data)}
                handleCreate={() => handleEmpty(true)}
                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
            />
            <PurchaseCustomForm
                supplierId={supplierId}
                roleManagement={roleManagement}
                changeHandler={(e, fieldName) => changeHandler(e, fieldName)}
                handleProductChange={(data) => handleProductChange(data)}
                handleIsActive={(data) => setForm({ ...form, "isActive": data })}
                form={{ ...form }}
                title={title}
                view={view}
                priceId={priceId}
                error={{ ...error }}
                customObject={(details, id) => customObject(details, id)}
                commonError={commonError}
                handleSubmit={(e) => handleSubmit(e)}
                handleClose={() => handleEmpty(false)} visible={visible}
                handleEdit={(d) => setView(d)}
                productApi={(s = '', id = '') => productApi(s, id)}
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={priceId} loadTasks={() => dispatchFilter(dateValue, sortBy, sortOrder)}
                name={form?.purchasePriceId} url={'purchase-prices'}
                title={'Purchase Price'} visible={deleteModal}
            />
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={"Supplier Purchase Price"}
                type={'import'}
                loader={purchasePriceLoader}
                loadImportExportData={(name, type, selected, extension, exportType) => loadImportExportData(name, type, selected, extension, exportType)}
                details={purchasePriceDetails}
                loadTasks={() => dispatchFilter(dateValue, sortBy, sortOrder)}
            />
        </React.Fragment>
    )
})

export default PurchasePrice